import { ComponentProps } from "../registry";
import { useBound } from "../helpers";
import { BoundValue } from "../../types";

export function AudioPlayer({ fields, scope }: ComponentProps) {
  const url = useBound<string>(fields.url as BoundValue, scope);
  const desc = useBound<string>(fields.description as BoundValue, scope);
  if (!url) return null;
  return (
    <div className="a2-audio">
      {desc && <div className="a2-audio-desc">{desc}</div>}
      <audio src={url} controls />
    </div>
  );
}
